import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import usePageStore from './Page/pageStore';
import MaskedText from './UI/MaskedText';
const HomeStorySection = ({ content, idx, allowOpen, }) => {
    const { activeSection, shownSection } = usePageStore();
    if (!content.name)
        return null;
    return (_jsx(_Fragment, { children: _jsx("div", { className: "fixed-container-slider fixed-container-title", children: _jsx(MaskedText, { text: content.name, idx: 0, isOpen: allowOpen && shownSection === idx && activeSection === idx }, content.name) }) }));
};
export default HomeStorySection;
